import PdtList from './PdtList';
import Settings from './Settings';

export default {
  PdtList,
  Settings,
};
